import React from "react";
import { ServicesViewWrap } from "./ServicesViewWrap";

const ServicesReactView = () => {
  return <ServicesViewWrap />;
};

window.ServicesReactView = ServicesReactView;
